// DON'T EDIT THIS FILE!! IT'S AUTO-GENERATED USING GRAPHQL-CODE-GENERATOR CLI
/* eslint-disable camelcase */
import * as Types from '../../../Types/__generated__/types';

import gql from 'graphql-tag.macro';
import * as ApolloReactCommon from 'react-apollo';
import * as ApolloReactHooks from '@apollo/react-hooks';

export type MainFooterAssignCountryMutationMutationVariables = Types.Exact<{
  countryCode: Types.Scalars['String'];
  url: Types.Scalars['String'];
}>;

export type MainFooterAssignCountryMutationMutation = {
  __typename?: 'PublicMutations';
  assignCountry?: Types.Maybe<{
    __typename?: 'AssignCountryMutationPayload';
    success?: Types.Maybe<boolean>;
    url?: Types.Maybe<string>;
  }>;
};

export const MainFooterAssignCountryMutationDocument = gql`
  mutation MainFooterAssignCountryMutation(
    $countryCode: String!
    $url: String!
  ) {
    assignCountry(input: { countryCode: $countryCode, url: $url }) {
      success
      url
    }
  }
`;

/**
 * __useMainFooterAssignCountryMutationMutation__
 *
 * To run a mutation, you first call `useMainFooterAssignCountryMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMainFooterAssignCountryMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mainFooterAssignCountryMutationMutation, { data, loading, error }] = useMainFooterAssignCountryMutationMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useMainFooterAssignCountryMutationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    MainFooterAssignCountryMutationMutation,
    MainFooterAssignCountryMutationMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    MainFooterAssignCountryMutationMutation,
    MainFooterAssignCountryMutationMutationVariables
  >(MainFooterAssignCountryMutationDocument, baseOptions);
}
export type MainFooterAssignCountryMutationMutationHookResult = ReturnType<
  typeof useMainFooterAssignCountryMutationMutation
>;
export type MainFooterAssignCountryMutationMutationResult = ApolloReactCommon.MutationResult<
  MainFooterAssignCountryMutationMutation
>;
export type MainFooterAssignCountryMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<
  MainFooterAssignCountryMutationMutation,
  MainFooterAssignCountryMutationMutationVariables
>;
